import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { CheckCircle2, AlertTriangle, XCircle, ArrowRight } from "lucide-react";

const STYLES = {
  green: { bg: "bg-emerald-50", border: "border-emerald-500", text: "text-emerald-800", Icon: CheckCircle2 },
  orange: { bg: "bg-amber-50", border: "border-amber-500", text: "text-amber-800", Icon: AlertTriangle },
  red: { bg: "bg-red-50", border: "border-red-500", text: "text-red-800", Icon: XCircle },
};

export default function MigrationReadinessBanner({ companyId, taxYear }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isClient = user?.role !== "super_admin";
  const [r, setR] = useState(null);
  const year = taxYear || new Date().getFullYear();

  useEffect(() => {
    if (!companyId) return;
    api.get(`/companies/${companyId}/migration/readiness?tax_year=${year}`).then((res) => setR(res.data)).catch(() => setR(null));
  }, [companyId, year]);

  if (!r || r.closed) return null;
  const s = STYLES[r.state] || STYLES.orange;
  const c = r.counts || {};
  const go = () => navigate(`${isClient ? "/client" : ""}/migration?company=${companyId}`);

  return (
    <div className={`border-l-4 ${s.border} ${s.bg} p-4 mb-6`} data-testid="migration-readiness-banner" data-state={r.state}>
      <div className="flex flex-wrap items-center gap-3">
        <s.Icon className={`h-5 w-5 ${s.text}`} />
        <div className={`text-sm font-black tracking-tight ${s.text}`} data-testid="migration-readiness-label">{r.label}</div>
        <div className="text-xs text-muted-foreground flex flex-wrap gap-x-4 gap-y-1 flex-1">
          <span data-testid="mrb-active">Active payroll employees: <b>{c.active ?? 0}</b></span>
          <span data-testid="mrb-opening">Opening balances complete: <b>{c.opening_complete ?? 0}</b></span>
          <span data-testid="mrb-newhire">New hires confirmed: <b>{c.new_hire_confirmed ?? 0}</b></span>
          <span data-testid="mrb-review">Needs review: <b>{c.needs_review ?? 0}</b></span>
          <span data-testid="mrb-critical">Critical errors: <b className={c.critical ? "text-red-600" : ""}>{c.critical ?? 0}</b></span>
        </div>
        <button data-testid="migration-readiness-review" onClick={go} className="inline-flex items-center gap-1.5 border border-current px-3 py-1.5 text-xs font-medium hover:bg-black hover:text-white hover:border-black transition-colors">
          Review Migration <ArrowRight className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
